import type { RefObject } from "react";

import { CaptureResetWarning } from "#/components/game/CaptureResetWarning";
import { GameDockedPanelShell } from "#/components/game/GameDockedPanelShell";
import { useGameSelector } from "#/game/GameStoreProvider";
import { persistGameplaySetting } from "#/lib/persistGameplaySetting";
import { useRequestGameContext } from "#/lib/useRequestGameContext";

export function CaptureResetWarningOverlay({
  bottomDockRef,
}: {
  bottomDockRef: RefObject<HTMLElement | null>;
}) {
  const selection = useGameSelector((s) => s.selection);
  const isSubmitting = useGameSelector((s) => s.isSubmitting);
  const confirmCaptureReset = useGameSelector((s) => s.confirmCaptureReset);
  const cancelCaptureReset = useGameSelector((s) => s.cancelCaptureReset);
  const setCaptureResetWarning = useGameSelector((s) => s.setCaptureResetWarning);
  const { isAnonymous } = useRequestGameContext();

  if (selection.mode !== "confirm-capture-reset") return null;

  const handleConfirm = (suppressFuture: boolean) => {
    if (suppressFuture) {
      setCaptureResetWarning(false);
      void persistGameplaySetting({
        setting: "captureResetWarning",
        enabled: false,
        isAnonymous,
      });
    }
    confirmCaptureReset();
  };

  return (
    <GameDockedPanelShell
      bottomDockRef={bottomDockRef}
      onCancel={cancelCaptureReset}
      closeAriaLabel="Cancel leaving capture"
      panelWidth="fit"
    >
      <CaptureResetWarning
        onConfirm={handleConfirm}
        onCancel={cancelCaptureReset}
        disabled={isSubmitting}
      />
    </GameDockedPanelShell>
  );
}
